import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";

const StyledLoader = styled.div`
  .loading-loader {
    opacity: 0;
    transition: opacity 600ms;
    display: flex;
    align-items: center;
    color: #d8dbe2;

    &.is-loading {
      opacity: 1;
    }

    & > *:not(:last-child) {
      margin-right: 10px;
    }

    .loader {
      animation: rotate 2s linear infinite;
    }

    @keyframes rotate {
      100% {
        transform: rotate(360deg);
      }
    }

    .loader circle {
      animation: dash 1.5s ease-in-out infinite;
    }

    @keyframes dash {
      0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
      }
    }
  }
`;

const Loader = ({ loading, size }) => (
  <StyledLoader>
    <div className={`loading-loader ${loading ? "is-loading" : ""}`}>
      <svg
        className="loader"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
      </svg>
      <span>Loading</span>
    </div>
  </StyledLoader>
);

Loader.propTypes = {
  size: PropTypes.number,
  loading: PropTypes.bool
};
Loader.defaultProps = {
  size: 24
};
export default Loader;
